<template>
  <div>
    <div class="d-flex justify-content-center align-items-center mt-4">
      <b-alert variant="outline-info" show>
        <h3>
          {{ $t('mobile.rotatePhone') }}
        </h3>
      </b-alert>
    </div>
    <div class="d-flex justify-content-center align-items-center mt-4">
      <b-button variant="outline-success" :to="{name: 'login'}">{{ $t('mobile.login') }}</b-button>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "Mobile",
  props: ['username', 'password'],
  mounted() {
    if (this.username && this.password){
      this.$store.dispatch("auth/login", {
        username: this.username,
        password: this.password
      });
    }
  }
}
</script>

<style scoped>



</style>